import { render, staticRenderFns } from "./Form2ProcessHeader.vue?vue&type=template&id=2166a42b&scoped=true"
import script from "./Form2ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form2ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form2ProcessHeader.vue?vue&type=style&index=0&id=2166a42b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166a42b",
  null
  
)

export default component.exports